module.exports = __webpack_public_path__ + "static/media/img_profile_miyazaki.2696a73f.png";